import { Loadable } from '../../../components/common/loadable/loadable';

export const ApplicationOverviewContainer = Loadable<any>({
  loader: () =>
    import(
      /* webpackChunkName: "application-overview" */ './application-overview'
    ).then((module) => module.ApplicationOverviewContainer),
});
